import { makeObservable, observable } from 'mobx'

class newExploriAdminStore {
    @observable ready = false

    @observable form = {
        clientId: [],
        salutation: '',
        firstName: '',
        lastName: '',
        jobTitle: '',
        email: '',
        isExploriAdmin: false,
        isExploriReseller: false,
        timezone: 'Europe/London',
        langcode: 'en_GB',
    }

    @observable isSaving = false

    clients = []

    formFields = [
        {
            name: 'salutation',
            type: 'input',
            label: 'Salutation',
        },
        {
            name: 'firstName',
            type: 'input',
            label: 'First Name',
        },
        {
            name: 'lastName',
            type: 'input',
            label: 'Last Name',
        },
        {
            name: 'jobTitle',
            type: 'input',
            label: 'Job Title',
        },
        {
            name: 'email',
            type: 'input',
            label: 'Email',
            isMandatory: true,
        },
        {
            name: 'isExploriAdmin',
            type: 'CH',
            label: 'Is Explori Admin',
        },
        {
            name: 'isExploriReseller',
            type: 'CH',
            label: 'Is Explori Reseller',
        },
    ]

    fieldValidations = {}

    constructor(store) {
        makeObservable(this)
        this.appStore = store
    }

    init = async (history) => {
        await this.loadClients()
        this.history = history
        this.ready = true
    }

    register = (name, validate) => {
        this.fieldValidations[name] = validate
    }

    unregister = (name) => {
        Reflect.deleteProperty(this.fieldValidations, name)
    }

    loadClients = async () => {
        let clients = []

        try {
            const response = await this.appStore.http.get('/client')
            clients = response.clients.map(({ clientId, name }) => ({
                label: `${name} [${clientId}]`,
                value: Number(clientId),
            }))
        } catch (e) {
            console.error(`Error loading clients -> ${e}`)
        }

        this.clients = clients
    }

    selectAll = () => {
        this.form.clientId = []
    }

    changeclientIds = (obj) => {
        console.log('changeclientIds', JSON.stringify(obj, null, 4))
        this.form.clientId = obj.value

        console.log('changeclientIds', this.clients)
    }

    changeFormField = ({ name, value }) => {
        this.form[name] = value
    }

    save = async () => {
        if (this.isSaving) return

        this.isSaving = true
        const isInvalid = Object.entries(this.fieldValidations)
            .some(([name, validate]) => {
                console.log('isValid', name, this.formFields[name], validate({ name, value: this.form[name] }, true))
                return !validate({ name, value: this.form[name] }, true)
            })

        try {
            if (!isInvalid) {
                await this.appStore.http.post('/intranet/addNewExploriAdminUser', JSON.stringify(this.form))
                this.appStore.addNotification(null, 'Explori admin created', 'success')
                this.history.push('/intranet')
            }
        } catch (e) {
            console.error(e)
            this.appStore.addNotification(null, 'Error creating explori admin', 'error')
        } finally {
            this.isSaving = false
        }
    }
}

export default newExploriAdminStore
